import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowRandom = () => {
  return (
    <g>
      <path d="m10.6768 7.2315h-5.3477a.75.75 0 0 0 0 1.5h5.3477a.75.75 0 0 0 0-1.5z" />
      <path d="m15.7222 2.5977-1.7281-2.2549c-.0084-.011-.0226-.0145-.0317-.0249a.7247.7247 0 0 0 -1.1271 0c-.009.01-.0232.0139-.0317.0249l-1.728 2.2549a.75.75 0 1 0 1.19.9121l.3828-.4993v4.7131c0 1.3574-.7622 2.5049-1.6641 2.5049h-5.6552a.75.75 0 0 0 0 1.5h5.6558c1.7446 0 3.1641-1.7969 3.1641-4.0049v-4.7136l.3828.4993a.75.75 0 1 0 1.19-.9121z" />
      <path d="m3.7339 12.49-.3828.4993v-4.7129c0-1.3574.7622-2.5049 1.6641-2.5049h5.6616a.75.75 0 0 0 0-1.5h-5.6617c-1.7446 0-3.1641 1.7969-3.1641 4.0049v4.7136l-.3827-.5a.75.75 0 1 0 -1.19.9121l1.728 2.2549c.009.0118.0238.0164.0334.0275a.7354.7354 0 0 0 .1714.1411.7224.7224 0 0 0 .0779.0525.7068.7068 0 0 0 .6249 0 .7222.7222 0 0 0 .0779-.0525.7358.7358 0 0 0 .1714-.1411c.01-.0112.0245-.0157.0334-.0275l1.728-2.2549a.75.75 0 1 0 -1.19-.9121z" />
    </g>
  );
};

export default withIcon(IconArrowRandom);
